import { useNavigate } from "react-router";

export function ImpressumPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-6 sm:px-6">
          <button
            onClick={() => navigate("/")}
            className="text-blue-600 hover:text-blue-700"
          >
            ← Zurück
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
        <h1 className="mb-8 text-4xl font-bold text-gray-900">Impressum</h1>

        <section className="space-y-8">
          <div>
            <h2 className="mb-4 text-2xl font-semibold text-gray-900">
              Angaben gemäß § 5 TMG und § 7 Abs. 1 MMStV
            </h2>
            <p className="mb-4 text-gray-700">
              <strong>Betreiber der Operio-Plattform:</strong>
              <br />
              Alexander Bolz
              <br />
              Guttenberger Str. 25
              <br />
              97234 Reichenberg
              <br />
              Deutschland
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Kontaktangaben
            </h3>
            <p className="text-gray-700">
              <strong>Telefon:</strong>{" "}
              <a
                href="tel:+491556286516"
                className="text-blue-600 hover:text-blue-700"
              >
                +49 15562 862516
              </a>
              <br />
              <strong>E-Mail:</strong>{" "}
              <a
                href="mailto:kontakt@altibo.de"
                className="text-blue-600 hover:text-blue-700"
              >
                kontakt@altibo.de
              </a>
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Plattformbeschreibung
            </h3>
            <p className="text-gray-700">
              Operio ist ein webbasiertes Software-as-a-Service (SaaS) Angebot
              zur Verwaltung von Kundendaten, Rechnungen und
              Geschäftstransaktionen. Die Plattform richtet sich an
              Dienstleister, Handwerker und Freiberufler im deutschsprachigen
              Raum.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Haftungsausschluss
            </h3>
            <p className="mb-3 text-gray-700">
              <strong>Inhalte:</strong> Die Inhalte dieser Website werden mit
              Sorgfalt erstellt. Wir bemühen uns, die Aktualität, Richtigkeit
              und Vollständigkeit zu gewährleisten. Wir übernehmen jedoch keine
              Haftung für die Richtigkeit der bereitgestellten Informationen und
              schließen die Haftung für mittelbare und unmittelbare Schäden aus.
            </p>
            <p className="text-gray-700">
              <strong>Links:</strong> Für den Inhalt fremder Websites, auf die
              wir verlinken, sind wir nicht verantwortlich. Die Verantwortung
              liegt ausschließlich bei den Betreibern der verlinkten Seiten.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Softwarefunktion
            </h3>
            <p className="text-gray-700">
              Operio bietet Funktionen zur Verwaltung von Geschäftsdaten wie
              Kundenkontakte, Rechnungen, Zahlungen und Berichte. Die Plattform
              kann dabei unterstützend bei kaufmännischen Tätigkeiten eingesetzt
              werden, ersetzt aber keine professionelle Steuerberatung oder
              rechtliche Beratung.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Urheber- und Markenrechte
            </h3>
            <p className="text-gray-700">
              Alle Inhalte dieser Website (Text, Bilder, Grafiken, Logos) sind
              urheberrechtlich geschützt. Die Vervielfältigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
              Urheberrechtes bedürfen der Zustimmung des Autors oder Urhebers.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50 py-8 mt-12">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <div className="text-sm text-gray-600">
              © 2026 ALTIBO. Operio ist ein Produkt von Alexander Bolz.
            </div>
            <div className="flex gap-6 text-sm">
              <a href="/impressum" className="font-semibold text-gray-900">
                Impressum
              </a>
              <a
                href="/datenschutz"
                className="text-blue-600 hover:text-blue-700"
              >
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
